/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				/**
				 * This snippet apparently prevents the browser from jumping to the
				 * iframe Facebook feed should there be a Facebook related issue
				 */
				window.onload = function() {
					$( ".facebook-widget-wrap iframe" ).show();
				};


				// Menu adjustment for new white nav menu
				$( document ).on( "breakpoint:changed", function( evt, newBreakpointName ) {
					if( ( newBreakpointName === "lg" ) || ( newBreakpointName === "xl" ) ) {

						// Prepend menu on anything but home page
						if( $( ".dogtopia-extra-nav-container" ).length > 0 &&
										 $( ".home-page-header-nav-v2" ).length == 0 ) {
							$( ".dogtopia-extra-nav-container" ).prependTo( ".dogtopia-header-extra-nav" );
						}

						// Prepend menu only on the home page
						else if( $( ".dogtopia-extra-nav-container" ).length > 0 &&
										 $( ".home-page-header-nav-v2" ).length > 0 ) {
							$( ".dogtopia-extra-nav-container" ).prependTo( ".home-page-header-extra-nav" );
						}
					}

					// else if( $( ".dogtopia-extra-nav-container" ).length > 0  ) {
					// 	$( ".dogtopia-extra-nav-container" ).prependTo( ".mobile-collapsible-nav-wrap .collapsible-nav-content-wrap" );
					// }	
				} );




				

				$(".page-footer-form-column textarea:not(.scroll-height-measure-clone)")
					.each(function(){

						var textareaClone = $(this).clone();

						textareaClone.addClass("scroll-height-measure-clone");

						$(this).after(textareaClone);

					})
					.on("focus", function(evt){

						var borderPaddingHeight = (parseFloat($(this).css("borderWidth")) * 2) + (parseFloat($(this).css("paddingTop")) * 2);

						var textareaHeight = parseFloat($(this).css("height"));

						var singleLineHeight = parseFloat($(this).css("lineHeight"));

						if((textareaHeight - borderPaddingHeight) <= singleLineHeight){
							$(this).css("height", ((singleLineHeight * 2) + borderPaddingHeight));
						}

					})
					.on("blur", function(evt){

						if($(this).val() === ""){

							var borderPaddingHeight = (parseFloat($(this).css("borderWidth")) * 2) + (parseFloat($(this).css("paddingTop")) * 2);

							var singleLineHeight = parseFloat($(this).css("lineHeight"));

							$(this).css("height", (singleLineHeight + borderPaddingHeight));

						}

					})
					.on("input", function(evt){

						var currentTextareaHeight = parseFloat($(this).css("height"));

						$(this).next().val($(this).val());

						var textareaScrollHeight = $(this).next().prop("scrollHeight") + (parseFloat($(this).css("borderWidth")) * 2);

						var desiredScrollHeight = textareaScrollHeight + parseFloat($(this).css("lineHeight"));

						if(currentTextareaHeight !== desiredScrollHeight){
							$(this).css("height", (desiredScrollHeight + "px"));
						}

					});

				var nestedFieldSector =
					'.ginput_complex [class^="ginput_"] > input[type!="hidden"], ' +
					'.ginput_complex [class^="ginput_"] > select';

				var bookingFormSector = '.booking-form-field';

				$(document).on("gform_post_render", function(){
					$(".training-long-form_wrapper").find(nestedFieldSector).each(function(){
						if($(this).val() !== ""){
							$(this).closest(".ginput_full, .ginput_left, .ginput_right").addClass("has-focus-or-value");
						}
					});
				});

				$(".training-long-form_wrapper")
					.on("focus", nestedFieldSector, function(){
						$(this).closest(".ginput_full, .ginput_left, .ginput_right").addClass("has-focus-or-value");
					})
					.on("blur", nestedFieldSector, function(){
						if($(this).val() === ""){
							$(this).closest(".ginput_full, .ginput_left, .ginput_right").removeClass("has-focus-or-value");
						}
					});

				$( ".booking-form-container" )
					.on( "focus", bookingFormSector, function() {
						$( this ).closest( ".booking-form-input-container" ).addClass( "has-focus-or-value" );
					} )
					
					.on( "blur", bookingFormSector, function() {
						if( $( this ).val() === "" ) {
							$( this ).closest( ".booking-form-input-container" ).removeClass( "has-focus-or-value" );
						}
					} );

					$( "#mobile-nav-toggler" ).on( "click", function() {
						
						// switch between full logo and icon
						if( $( ".full-dogtopia-logo" ).hasClass( 'uk-hidden' ) ) {
							$( ".full-dogtopia-logo" ).removeClass( 'uk-hidden' );
							$( ".dogtopia-icon" ).addClass( 'uk-hidden' );
						}

						else {
							$( ".full-dogtopia-logo" ).addClass( 'uk-hidden' );
							$( ".dogtopia-icon" ).removeClass( 'uk-hidden' );
						}

						if( $( ".dogtopia-alert-container" ).length > 0 ) {
							if( $( ".dogtopia-alert-container" ).hasClass( 'uk-hidden' ) ) {
								setTimeout( function () {
									$( ".dogtopia-alert-container" ).removeClass( 'uk-hidden' );
								}, 500);
							}

							else {
								$( ".dogtopia-alert-container" ).addClass( 'uk-hidden' );
							}
						}
					});

					$( "#headerAlertBtn" ).on( "click", function() {
						var fullMsg  = document.getElementById( "alertFullMsg" );
						var alertBtn = document.getElementById( "headerAlertBtn" );
		
						if( fullMsg.style.display === "none" ) {				
							alertBtn.innerHTML 		= "Read more"; 
							fullMsg.style.display = "none";
						} 
						
						else {
							alertBtn.innerHTML	  = ""; 
							fullMsg.style.display = "inline";
						}
					} );
				

					
					// display in mobile menu dropdown
					if( typeof dailyHoursData !== "undefined" ) {
						var currDate 				 = new Date();
						var currDayOfWeekInt = currDate.getDay();
						var todaysHoursHtml  = "";

						if( dailyHoursData[ currDayOfWeekInt ].length > 0 ) {
							todaysHoursHtml = '<p>Hours Today: <br />' + dailyHoursData[ currDayOfWeekInt ][0] + '</p>';
						}

						$( ".js-mobile-menu-todays-hours" ).append( todaysHoursHtml );
					}
					



			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		'home': {
			init: function() {

				if(typeof dailyHoursData !== "undefined"){

					var currDate = new Date();

					var currDayOfWeekInt = currDate.getDay();
					
					var todaysHoursHtml = "";

					if(dailyHoursData[currDayOfWeekInt].length > 1){

						todaysHoursHtml =
							'<table>' +
								'<tbody>' +
									'<tr>' +
										'<td><h5>Hours Today:</h5></td>' +
										'<td><h5>' + dailyHoursData[currDayOfWeekInt][0] + '</h5></td>' +
									'</tr>' +
									'<tr>' +
										'<td></td>' +
										'<td><h5>' + dailyHoursData[currDayOfWeekInt][1] + '</h5></td>' +
									'</tr>' +
								'</tbody>' +
							'</table>';

					}else if(dailyHoursData[currDayOfWeekInt].length > 0){

						todaysHoursHtml = '<h5>Hours Today: ' + dailyHoursData[currDayOfWeekInt][0] + '</h5>';

					}

					$(".js-todays-hours").append(todaysHoursHtml);

				}




				if( $( '.view-details-link' ).length > 0 ) {
					$( '.view-details-link' ).on( 'click',
						function() {
							if( $( this ).hasClass( "details-opened" ) ) {
								$( this ).removeClass( "details-opened" );
								$( this ).text( 'view details' );
							} else {
								$( this ).addClass( "details-opened" );
								$( this ).text( 'close details' );
							}
						}
					);
				}

				if( $( '.coming-soon-pop-up-modal-container' ).length > 0 ) {
					$( "#comingSoonTrigger" ).delay( 2000 ).click();
				}
			},

			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		
		'page_founders_offer': {
			init: function() {

				$(document).on("gform_post_render", function(){
					$('.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]')
						.each(function(){
							if($(this).val() !== ""){
								$(this).closest(".ginput_full").addClass("has-focus-or-value");
							}
						});
				});

				$(document).on("gform_confirmation_loaded", function(){

					$(".call-out-content-box .gform_confirmation_wrapper").prevAll("p").hide();

				});

				$(".gform_wrapper")
					.on("focus", '.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]', function(){
						$(this).closest(".ginput_full").addClass("has-focus-or-value");
					})
					.on("blur", '.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]', function(){
						if($(this).val() === ""){
							$(this).closest(".ginput_full").removeClass("has-focus-or-value");
						}
					});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		'page_founders_offer_form': {
			init: function() {

				$(document).on("gform_post_render", function(){
					$('.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]')
						.each(function(){
							if($(this).val() !== ""){
								$(this).closest(".ginput_full").addClass("has-focus-or-value");
							}
						});
				});

				$(document).on("gform_confirmation_loaded", function(){

					$(".call-out-content-box .gform_confirmation_wrapper").prevAll("p").hide();

				});

				$(".gform_wrapper")
					.on("focus", '.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]', function(){
						$(this).closest(".ginput_full").addClass("has-focus-or-value");
					})
					.on("blur", '.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]', function(){
						if($(this).val() === ""){
							$(this).closest(".ginput_full").removeClass("has-focus-or-value");
						}
					});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		'page_founders_offer_form_v4': {
			init: function() {

				$(document).on("gform_post_render", function(){
					$('.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]')
						.each(function(){
							if($(this).val() !== ""){
								$(this).closest(".ginput_full").addClass("has-focus-or-value");
							}
						});
				});

				$(document).on("gform_confirmation_loaded", function(){

					$(".call-out-content-box .gform_confirmation_wrapper").prevAll("p").hide();

				});

				$(".gform_wrapper")
					.on("focus", '.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]', function(){
						$(this).closest(".ginput_full").addClass("has-focus-or-value");
					})
					.on("blur", '.ginput_container_creditcard .ginput_full > input[type!="hidden"], .ginput_container_creditcard .ginput_cardinfo_right > input[type!="hidden"]', function(){
						if($(this).val() === ""){
							$(this).closest(".ginput_full").removeClass("has-focus-or-value");
						}
					});
				},
				finalize: function() {
					// JavaScript to be fired on all pages, after page specific JS is fired
				}
			},

		'page_service_dog': {
			init: function() {
				if( screen.width < 660) {
					// console.log(navigator.userAgent);
					$('.sdog-list-wrap').each(function(){
							if( $(this).find('.sdog-contents').length > 3) {    
									/*console.log($(this).find('.sdog-contents').length);*/
									$('.sdog-contents', this).eq(1).nextAll().hide().addClass('toggleable');
									$(this).append('<div class="btn-loadmore btn btn-danger more">Show more dogs</div>');    
							}
							$(this).on('click','.more', function() {
								var opened = $(this).hasClass('less');  
								$(this).text(opened ? 'More...' : 'Less...').toggleClass('less', !opened);    
								$(this).siblings('div.toggleable').slideToggle();
							});
					});
				}
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},

		'page_splash': {
			init: function() {

				// Check if constant contact has been setup
				if( $( '.dogtopia-splash-page-ctct-container').length > 0 ) {
									
					// Delay functions so ctct form elements can load first.
					setTimeout( function() {
						$( '.dogtopia-ctct-container input' ).change( function() {
							$( '.dogtopia-splash-page-ctct-container input' ).val( $( this ).val() );
						} );

						$( '.dogtopia-ctct-container button' ).on( 'click', function() {
							setTimeout( function() {
								var pageErrorField = $( 
									'.dogtopia-splash-page-ctct-container .ctct-form-field .ctct-form-errorMessage'
								);

								// Return + set error from page form if visible
								if( pageErrorField.is( ":visible" ) ) {
									var error						 = pageErrorField.text();
									var footerErrorField = $(
										'.dogtopia-ctct-container .ctct-form-field .ctct-form-errorMessage'
									);

									footerErrorField.show();
									footerErrorField.text( error );
								}
							}, 1000 );
						} );
					}, 5000 );
				}
			},

			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
